import { useEffect, useRef } from 'react';
import createGlobe from 'cobe';
import { motion, useScroll, useTransform } from 'framer-motion';

export function Cobe() {
  const canvasRef = useRef<any>(null);
  const { scrollY } = useScroll();

  const xPosition = useTransform(scrollY, [0, 400], ['-50%', '-50%']);
  const scale = useTransform(scrollY, [0, 200], [1.2, 0.9]);

  useEffect(() => {
    let phi = 0;
    let width = 0;

    const onResize = () => canvasRef.current && (width = canvasRef.current.offsetWidth);
    window.addEventListener('resize', onResize);
    onResize();

    const globe = createGlobe(canvasRef.current, {
      devicePixelRatio: 2,
      width: width * 2,
      height: width * 2,
      phi: 0,
      theta: 0.3,
      dark: 1,
      diffuse: 3,
      mapSamples: 16000,
      mapBrightness: 2.2,
      baseColor: [0, 1, 300 / 255], // Use RGB format without alpha
      markerColor: [0, 1, 211 / 255], // Use RGB format without alpha
      glowColor: [0, 0, 0], // Use RGB format without alpha
      markers: [],
      onRender: state => {
        state.phi = phi;
        phi += 0.005;
        state.width = width * 2;
        state.height = width * 2;
      },
    });

    setTimeout(() => (canvasRef.current.style.opacity = '1'));

    return () => {
      globe.destroy();
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <motion.div
      style={{
        width: '100%',
        maxWidth: 600,
        aspectRatio: 1,
        margin: 'auto',
        position: 'fixed',
        top: '10%',
        left: '50%',
        x: xPosition,
        transform: 'translate(-50%, -50%)',
        scale,
        objectFit: 'contain',
        zIndex: -150,
        mixBlendMode: 'lighten',
        opacity: 0.7, // Apply opacity here for reduced effect
      }}
    >
      <canvas
        ref={canvasRef}
        style={{
          width: '100%',
          height: '100%',
          contain: 'layout paint size',
          opacity: 0,
          transition: 'opacity 1s ease',
        }}
      />
    </motion.div>
  );
}
